import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { useError } from '../../hooks/useError';
import ErrorMessage from '../ErrorMessage';
import { getSportTypeConfig } from '../../sports/configs';

export const Layout = ({ sportType, heroBannerUrl, children }) => {
    const { error } = useError();

    useEffect(() => {
        if (error) {
            // Scroll the user to the error at the top of the page.
            window.scrollTo(0, 0);
        }
    });

    const bannerSrc =
        heroBannerUrl ||
        (sportType && getSportTypeConfig(sportType).assets.bannerImage);

    return (
        <Styled.LayoutWrapper>
            {bannerSrc && (
                <Styled.BannerImage
                    src={bannerSrc}
                    alt={sportType ? `${sportType} banner` : 'Banner image'}
                />
            )}
            <ErrorMessage message={error} />
            {children}
            <Styled.Footer>
                <div>
                    © Copyright ITV Consumer Limited {new Date().getFullYear()}.
                    The ITV Racing 7 and ITV Racing logos are trade marks of ITV
                    Rights Limited.
                </div>
            </Styled.Footer>
        </Styled.LayoutWrapper>
    );
};

Layout.defaultProps = {
    sportType: null,
    heroBannerUrl: null,
    children: null
};

Layout.propTypes = {
    sportType: PropTypes.oneOf(['football', 'racing']),
    heroBannerUrl: PropTypes.string,
    children: PropTypes.node
};

export default Layout;
